// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"761":"ed139089bc5c28c3a3e8","7090":"fb6718a5f35d5b28f7f9"}[chunkId] + ".chunk.js";
};